import KYCSettingsComponent from './KYCSettingsComponent';

export default KYCSettingsComponent;
